import Vue from 'vue'
import Router from 'vue-router'
// import constantRoutes from './constantRoutes' // 公共路由
import baseAsyncRoutes from './base/baseInfo.js'
import system from './system'
import flowableRoutes from './flow/flowable.js' // 流程定义路由
import managementRoutes from './flow/management.js' // 任务管理路由

import Layout from '@/layout'

Vue.use(Router)

export const constantRoutes = [

  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/lab/sampleRegistration/wts-page-office',
    component: () => import('@/views/lab/page-office/wts-page-office.vue'),
    hidden: true
  },
  {
    path: '/lab/DetectionTask/view_offince',
    component: () => import('@/views/lab/sampleTestingManagement/sampleTask/modules/components/view_offince'),
    hidden: true
  },

  {
    path: '/lab/sampleDispense/sampleRegistration/processCard',
    component: () => import('@/views/lab/takeSampleManagement/sampleRegistration/processCard'),
    funcPerms: 'lab:sample:register',
    name: 'processCard',
    hidden: true,
    meta: {
      title: '流程卡',
      icon: 'index',
      affix: false,
      noCache: true
    }
  },
  {
    path: '/lab/DetectionTask/office',
    component: () => import('@/views/lab/DetectionTask/office'),
    hidden: true
  },
  // {
  //   path: '/welcome',
  //   component: () => import('@/views/home/welcome.vue'),
  //   hidden: true
  // },
  // {
  //   path: '/baseIndex',
  //   component: () => import('@/views/dashboard/base/index'),
  //   name: 'BaseWelcome',
  //   meta: { title: '首页', icon: 'dashboard', affix: true }
  // },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/welcome',
    component: () => import('@/views/home/welcome'),
    hidden: true
  },
  {
    path: '/',
    redirect: '/welcome',
    hidden: true

  },
  {
    path: '/',
    component: Layout,
    redirect: '/welcome',
    children: [
      {
        path: 'center',
        component: () => import('@/views/personalCenter/index'),
        name: 'personalCenter',
        hidden: true,
        meta: { title: '个人中心', icon: 'dashboard', affix: false }
      }
    ]
  }

]
const route404 = {
  path: '*',
  redirect: '/404',
  hidden: true
}

const systemWelcome = {
  path: '/base',
  component: Layout,
  redirect: '/base/welcome',
  children: [{
    path: '/base/welcome',
    component: () => import('@/views/dashboard/index'),
    name: 'dashboardForBase',
    meta: {
      title: '系统管理首页',
      icon: 'dashboard',
      affix: true
    }
  }
  ]
}

const labWelcome = {
  path: '/lab',
  component: Layout,
  redirect: '/lab/welcome',
  children: [
    {
      path: '/lab/welcome',
      component: () => import('@/views/dashboard/labWelcome'),
      name: 'LabWelcome',
      meta: { title: '实验室首页', icon: 'dashboard', affix: true }
    }
  ]
}

const oaWelcome = {
  path: '/oa',
  component: Layout,
  redirect: '/oa/welcome',
  children: [
    {
      path: '/oa/welcome',
      component: () => import('@/views/dashboard/oaWelcome.vue'),
      name: 'OaWelcome',
      meta: {
        title: 'OA首页',
        icon: 'dashboard',
        affix: true
      }
    }

  ]
}

const purchaseWelcome = {
  path: '/purchase',
  component: Layout,
  redirect: '/purchase/welcome',
  children: [
    {
      path: '/purchase/welcome',
      component: () => import('@/views/dashboard/oaWelcome.vue'),
      name: 'OaWelcome',
      meta: {
        title: '采购首页',
        icon: 'dashboard',
        affix: true
      }
    }

  ]
}

const stockWelcome = {
  path: '/stock',
  component: Layout,
  redirect: '/stock/welcome',
  children: [
    {
      path: '/stock/welcome',
      component: () => import('@/views/dashboard/oaWelcome.vue'),
      name: 'StockWelcome',
      meta: {
        title: '库存首页',
        icon: 'dashboard',
        affix: true
      }
    }

  ]
}

export const systemRoutes = [
  systemWelcome, baseAsyncRoutes, flowableRoutes, managementRoutes, system, route404
]
export const labRoutes = [
  labWelcome,
  require('./lab/takeSampleManagement/index.js').default,
  require('./lab/DetectionTask/index.js').default,
  // require('./lab/testing/index.js').default,
  route404
]

export const oaRoutes = [
  oaWelcome,
  require('./oa/personnelManagement/employee.js').default,
  require('./oa/conference/index.js').default,
  // require('./oa/itemCategory/index.js').default,
  require('./oa/Personnel/index.js').default,
  // require('./oa/StorageLocation/index.js').default,
  require('./oa/sourceManagement/index.js').default,
  // require('./oa/reagentManagement/index.js').default,
  // require('./oa/consumablesManagement/index.js').default,
  // require('./oa/standardMarkersManagement/index.js').default,
  // require('./oa/otherStockManagement/index.js').default,
  // require('./oa/inoutStockDetail/index.js').default,
  require('./oa/inventory/index.js').default,
  require('./oa/purchaseManagement/index.js').default,
  require('./oa/financialManagement/index.js').default,
  route404
]

export const stockRoutes = [
  stockWelcome,
  require('./stock/StorageLocation/index.js').default,
  require('./stock/reagentManagement/index.js').default,
  require('./stock/consumablesManagement/index.js').default,
  require('./stock/standardMarkersManagement/index.js').default,
  require('./stock/otherStockManagement/index.js').default,
  require('./stock/inoutStockDetail/index.js').default,
  route404
]

export const purchaseRoutes = [
  purchaseWelcome,
  require('./purchase/purchase.js').default,
  require('./purchase/purchaseSubPage.js').default,
  require('./purchase/purchaseBidding.js').default,
  require('./purchase/purchaseContract.js').default,
  require('./purchase/purchasePutInStorage.js').default,
  require('./purchase/purchaseSetting.js').default,
  route404
]

const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// router.beforeEach(async (to, from, next) => {
//   let type = ''
//   if (to.path.startsWith('/oa')) type = 'oa'
//   else if (to.path.startsWith('/lab')) type = 'lab'
//   else if (to.path.startsWith('/base')) type = 'base'
//   else type = 'base'

//   if (store.state.app.systemType !== type) {
//     await store.dispatch('app/switchSystem', type)
//     switchSystemRoutes(type)
//     // 权限菜单
//     const info = await getInfo()
//     const permissions = Array.isArray(info.permissions) ? info.permissions : []
//     await store.dispatch('permission/generateMenus', permissions)
//   }
//   next()
// })

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

// export function switchSystemRoutes(type) {
//   currentSystemType = type
//   resetRouter(type)
// }

export default router
